import { createSlice } from '@reduxjs/toolkit';

import { updateOfferNote } from '../../thunks';
import { EFavoriteOffersActionTypes, IFavoriteChangedAction } from 'shared/types/actions/favorites';
import { IOffer, IOfferGroup, IOffersData } from 'shared/types/offers';

const initialState: IOffersData = {
  totalCount: 0,
  offers: [] as IOfferGroup[],
};

const handleUpdateOffer = (state: IOffersData, offerId: number, fieldsToUpdate: Partial<IOffer>) => {
  state.offers = state.offers.map(offerGroup => ({
    ...offerGroup,
    offers: offerGroup.offers
      ? offerGroup.offers.map(offer =>
          offer.id === offerId
            ? {
                ...offer,
                ...fieldsToUpdate,
              }
            : offer,
        )
      : undefined,
  }));

  return state;
};

const offersSlice = createSlice({
  name: 'offers',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(EFavoriteOffersActionTypes.UpdateFavorite, (state, action: IFavoriteChangedAction) =>
        handleUpdateOffer(state, action.payload.offerId, { isFavorite: action.payload.isFavorite }),
      )
      .addCase(updateOfferNote.fulfilled, (state, { payload }) => {
        if (!payload) {
          return state;
        }

        return handleUpdateOffer(state, payload.offerId, { notes: { offer: { text: payload.text } } });
      });
  },
  selectors: {
    selectOffers: state => state.offers,
    selectOffersCount: state => state.totalCount,
  },
});

export const {
  reducer: offersReducer,
  actions: offersActions,
  selectors: { selectOffers, selectOffersCount },
} = offersSlice;
